"use client";

import React from 'react';
import Link from 'next/link';
import { ArrowLeft, Book, Flame, Droplets, Sword, Coins } from 'lucide-react';
import { AboutLayout } from '@/components/about/about-layout';

const suits = [
  {
    name: "Wands",
    turkish: "Değnekler",
    element: "Ateş",
    icon: Flame,
    color: "from-red-500 to-orange-700",
    borderColor: "border-red-500/50",
    textColor: "text-red-400",
    description: "Tutku, yaratıcılık, enerji ve ruhsal güç",
    sampleCards: ["ace-of-wands.svg", "three-of-wands.svg", "queen-of-wands.svg"],
    cards: [
      { name: "Ace of Wands", slug: "ace-of-wands", image: "ace-of-wands.svg" },
      { name: "Two of Wands", slug: "two-of-wands", image: "two-of-wands.svg" },
      { name: "Three of Wands", slug: "three-of-wands", image: "three-of-wands.svg" },
      { name: "Four of Wands", slug: "four-of-wands", image: "four-of-wands.svg" },
      { name: "Five of Wands", slug: "five-of-wands", image: "five-of-wands.svg" },
      { name: "Six of Wands", slug: "six-of-wands", image: "six-of-wands.svg" },
      { name: "Seven of Wands", slug: "seven-of-wands", image: "seven-of-wands.svg" },
      { name: "Eight of Wands", slug: "eight-of-wands", image: "eight-of-wands.svg" },
      { name: "Nine of Wands", slug: "nine-of-wands", image: "nine-of-wands.svg" },
      { name: "Ten of Wands", slug: "ten-of-wands", image: "ten-of-wands.svg" },
      { name: "Page of Wands", slug: "page-of-wands", image: "page-of-wands.svg" },
      { name: "Knight of Wands", slug: "knight-of-wands", image: "knight-of-wands.svg" },
      { name: "Queen of Wands", slug: "queen-of-wands", image: "queen-of-wands.svg" },
      { name: "King of Wands", slug: "king-of-wands", image: "king-of-wands.svg" }
    ]
  },
  {
    name: "Cups",
    turkish: "Kupalar",
    element: "Su",
    icon: Droplets,
    color: "from-blue-500 to-cyan-700",
    borderColor: "border-blue-500/50",
    textColor: "text-blue-400",
    description: "Duygular, ilişkiler, sezgi ve ruhsal derinlik",
    sampleCards: ["ace-of-cups.svg", "two-of-cups.svg", "queen-of-cups.svg"],
    cards: [
      { name: "Ace of Cups", slug: "ace-of-cups", image: "ace-of-cups.svg" },
      { name: "Two of Cups", slug: "two-of-cups", image: "two-of-cups.svg" },
      { name: "Three of Cups", slug: "three-of-cups", image: "three-of-cups.svg" },
      { name: "Four of Cups", slug: "four-of-cups", image: "four-of-cups.svg" },
      { name: "Five of Cups", slug: "five-of-cups", image: "five-of-cups.svg" },
      { name: "Six of Cups", slug: "six-of-cups", image: "six-of-cups.svg" },
      { name: "Seven of Cups", slug: "seven-of-cups", image: "seven-of-cups.svg" },
      { name: "Eight of Cups", slug: "eight-of-cups", image: "eight-of-cups.svg" },
      { name: "Nine of Cups", slug: "nine-of-cups", image: "nine-of-cups.svg" },
      { name: "Ten of Cups", slug: "ten-of-cups", image: "ten-of-cups.svg" },
      { name: "Page of Cups", slug: "page-of-cups", image: "page-of-cups.svg" },
      { name: "Knight of Cups", slug: "knight-of-cups", image: "knight-of-cups.svg" },
      { name: "Queen of Cups", slug: "queen-of-cups", image: "queen-of-cups.svg" },
      { name: "King of Cups", slug: "king-of-cups", image: "king-of-cups.svg" }
    ]
  },
  {
    name: "Swords",
    turkish: "Kılıçlar",
    element: "Hava",
    icon: Sword,
    color: "from-gray-500 to-slate-700",
    borderColor: "border-gray-500/50",
    textColor: "text-gray-400",
    description: "Düşünce, mantık, çatışma ve zihinsel güç",
    sampleCards: ["ace-of-swords.svg", "three-of-swords.svg", "queen-of-swords.svg"],
    cards: [
      { name: "Ace of Swords", slug: "ace-of-swords", image: "ace-of-swords.svg" },
      { name: "Two of Swords", slug: "two-of-swords", image: "two-of-swords.svg" },
      { name: "Three of Swords", slug: "three-of-swords", image: "three-of-swords.svg" },
      { name: "Four of Swords", slug: "four-of-swords", image: "four-of-swords.svg" },
      { name: "Five of Swords", slug: "five-of-swords", image: "five-of-swords.svg" },
      { name: "Six of Swords", slug: "six-of-swords", image: "six-of-swords.svg" },
      { name: "Seven of Swords", slug: "seven-of-swords", image: "seven-of-swords.svg" },
      { name: "Eight of Swords", slug: "eight-of-swords", image: "eight-of-swords.svg" },
      { name: "Nine of Swords", slug: "nine-of-swords", image: "nine-of-swords.svg" },
      { name: "Ten of Swords", slug: "ten-of-swords", image: "ten-of-swords.svg" },
      { name: "Page of Swords", slug: "page-of-swords", image: "page-of-swords.svg" },
      { name: "Knight of Swords", slug: "knight-of-swords", image: "knight-of-swords.svg" },
      { name: "Queen of Swords", slug: "queen-of-swords", image: "queen-of-swords.svg" },
      { name: "King of Swords", slug: "king-of-swords", image: "king-of-swords.svg" }
    ]
  },
  {
    name: "Pentacles",
    turkish: "Pentagramlar",
    element: "Toprak",
    icon: Coins,
    color: "from-green-500 to-emerald-700",
    borderColor: "border-green-500/50",
    textColor: "text-green-400",
    description: "Maddi dünya, para, kariyer ve pratik işler",
    sampleCards: ["ace-of-pentacles.svg", "ten-of-pentacles.svg", "queen-of-pentacles.svg"],
    cards: [
      { name: "Ace of Pentacles", slug: "ace-of-pentacles", image: "ace-of-pentacles.svg" },
      { name: "Two of Pentacles", slug: "two-of-pentacles", image: "two-of-pentacles.svg" },
      { name: "Three of Pentacles", slug: "three-of-pentacles", image: "three-of-pentacles.svg" },
      { name: "Four of Pentacles", slug: "four-of-pentacles", image: "four-of-pentacles.svg" },
      { name: "Five of Pentacles", slug: "five-of-pentacles", image: "five-of-pentacles.svg" },
      { name: "Six of Pentacles", slug: "six-of-pentacles", image: "six-of-pentacles.svg" },
      { name: "Seven of Pentacles", slug: "seven-of-pentacles", image: "seven-of-pentacles.svg" },
      { name: "Eight of Pentacles", slug: "eight-of-pentacles", image: "eight-of-pentacles.svg" },
      { name: "Nine of Pentacles", slug: "nine-of-pentacles", image: "nine-of-pentacles.svg" },
      { name: "Ten of Pentacles", slug: "ten-of-pentacles", image: "ten-of-pentacles.svg" },
      { name: "Page of Pentacles", slug: "page-of-pentacles", image: "page-of-pentacles.svg" },
      { name: "Knight of Pentacles", slug: "knight-of-pentacles", image: "knight-of-pentacles.svg" },
      { name: "Queen of Pentacles", slug: "queen-of-pentacles", image: "queen-of-pentacles.svg" },
      { name: "King of Pentacles", slug: "king-of-pentacles", image: "king-of-pentacles.svg" }
    ]
  }
];

export default function MinorArcanaPage() {
  return (
    <AboutLayout activeSection="tarot">
      <div className="max-w-6xl mx-auto px-4 py-8">
        {/* Current Section Indicator */}
        <div className="mb-4 p-3 bg-emerald-500/10 border border-emerald-500/20 rounded-lg">
          <div className="flex items-center gap-2 text-emerald-300">
            <Book className="h-4 w-4" />
            <span className="text-sm font-medium">🃏 Tarot</span>
            <span className="text-emerald-500">/</span>
            <span className="text-sm">Rider-Waite</span>
            <span className="text-emerald-500">/</span>
            <span className="text-sm">Minör Arkana</span>
          </div>
        </div>

        {/* Breadcrumb */}
        <div className="mb-6">
          <Link
            href="/about"
            className="inline-flex items-center text-slate-400 hover:text-slate-200 transition-colors"
          >
            <ArrowLeft className="h-4 w-4 mr-2" />
            AXTROLOG Nedir
          </Link>
          <span className="text-slate-500 mx-2">/</span>
          <Link
            href="/about/tarot/systems"
            className="text-slate-400 hover:text-slate-200 transition-colors"
          >
            Tarot Sistemleri
          </Link>
          <span className="text-slate-500 mx-2">/</span>
          <Link
            href="/about/tarot/systems/rider-waite"
            className="text-slate-400 hover:text-slate-200 transition-colors"
          >
            Rider-Waite
          </Link>
          <span className="text-slate-500 mx-2">/</span>
          <span className="text-slate-300">Minör Arkana</span>
        </div>

        {/* Header */}
        <div className="bg-gradient-to-r from-emerald-900/20 to-teal-900/20 rounded-xl p-8 mb-8 border border-emerald-500/20">
          <h1 className="text-4xl font-bold text-slate-100 mb-4 flex items-center gap-3">
            <Book className="h-10 w-10 text-emerald-400" />
            Minör Arkana Kartları
          </h1>
          <p className="text-lg text-slate-200 leading-relaxed">
            Rider-Waite-Smith tarot destesinin 56 Minör Arkana kartı. Dört suit halinde gruplandırılmış,
            günlük yaşamın pratik yönleriyle ilgili kartlar.
          </p>
        </div>

        {/* Suits Grid */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 mb-8">
          {suits.map((suit) => {
            const IconComponent = suit.icon;
            return (
              <div key={suit.name} className={`bg-slate-800 rounded-xl p-6 border border-slate-700 hover:${suit.borderColor} transition-all duration-300`}>
                <div className="flex items-center gap-4 mb-6">
                  <div className={`w-16 h-16 bg-gradient-to-br ${suit.color} rounded-lg flex items-center justify-center`}>
                    <IconComponent className="h-8 w-8 text-white" />
                  </div>
                  <div>
                    <h2 className="text-2xl font-bold text-slate-100">{suit.name}</h2>
                    <p className="text-slate-400">{suit.turkish} - {suit.element} Elementi</p>
                  </div>
                </div>

                <p className="text-slate-300 mb-6 leading-relaxed">
                  {suit.description}
                </p>

                {/* Sample Cards Preview */}
                <div className="mb-6">
                  <h3 className="text-lg font-semibold text-slate-100 mb-4">Örnek Kartlar</h3>
                  <div className="flex gap-3 justify-center">
                    {suit.sampleCards.map((cardImage, index) => (
                      <div key={index} className="w-16 h-24 rounded-lg overflow-hidden shadow-lg hover:scale-105 transition-transform duration-300">
                        <img
                          src={`/images/tarot/cards/${cardImage}`}
                          alt={`${suit.name} örnek kart`}
                          className="w-full h-full object-cover"
                        />
                      </div>
                    ))}
                  </div>
                </div>

                <div className="mb-6">
                  <h3 className="text-lg font-semibold text-slate-100 mb-4">Kartlar (14 Adet)</h3>
                  <div className="grid grid-cols-2 gap-2">
                    {suit.cards.map((card, index) => (
                      <Link
                        key={card.slug}
                        href={`/about/tarot/systems/rider-waite/minor-arcana/${suit.name.toLowerCase()}/${card.slug}`}
                        className="text-sm text-slate-400 hover:text-slate-200 transition-colors p-2 rounded hover:bg-slate-700"
                      >
                        {index + 1}. {card.name}
                      </Link>
                    ))}
                  </div>
                </div>

                <Link
                  href={`/about/tarot/systems/rider-waite/minor-arcana/${suit.name.toLowerCase()}`}
                  className={`inline-flex items-center px-4 py-2 bg-gradient-to-r ${suit.color} text-white rounded-lg transition-colors hover:scale-105 transform duration-200`}
                >
                  <IconComponent className="h-4 w-4 mr-2" />
                  {suit.name} Kartlarını İncele
                </Link>
              </div>
            );
          })}
        </div>

        {/* Card Structure */}
        <div className="bg-slate-800 rounded-xl p-6 border border-slate-700 mb-8">
          <h2 className="text-2xl font-semibold text-slate-100 mb-6">Minör Arkana Yapısı</h2>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            <div>
              <h3 className="text-lg font-semibold text-slate-100 mb-3">Sayı Kartları (Pip Cards)</h3>
              <p className="text-slate-300 text-sm leading-relaxed mb-4">
                Her suit'te Ace'den 10'a kadar olan kartlar. RWS'nin en büyük yeniliği bu kartlarda
                detaylı görsel hikayeler sunmasıdır.
              </p>
              <div className="space-y-2">
                <div className="flex items-center gap-2">
                  <div className="w-2 h-2 bg-emerald-400 rounded-full"></div>
                  <span className="text-sm text-slate-400">Ace: Yeni başlangıçlar, saf enerji</span>
                </div>
                <div className="flex items-center gap-2">
                  <div className="w-2 h-2 bg-emerald-400 rounded-full"></div>
                  <span className="text-sm text-slate-400">2-4: Gelişim ve büyüme</span>
                </div>
                <div className="flex items-center gap-2">
                  <div className="w-2 h-2 bg-emerald-400 rounded-full"></div>
                  <span className="text-sm text-slate-400">5-7: Zorlu dönemler ve dersler</span>
                </div>
                <div className="flex items-center gap-2">
                  <div className="w-2 h-2 bg-emerald-400 rounded-full"></div>
                  <span className="text-sm text-slate-400">8-10: Olgunluk ve tamamlanma</span>
                </div>
              </div>
            </div>

            <div>
              <h3 className="text-lg font-semibold text-slate-100 mb-3">Saray Kartları (Court Cards)</h3>
              <p className="text-slate-300 text-sm leading-relaxed mb-4">
                Her suit'te dört saray kartı bulunur. Kişilikleri, yaş gruplarını veya
                yaklaşım biçimlerini temsil ederler.
              </p>
              <div className="space-y-2">
                <div className="flex items-center gap-2">
                  <div className="w-2 h-2 bg-emerald-400 rounded-full"></div>
                  <span className="text-sm text-slate-400">Page: Genç, öğrenci, yeni deneyimler</span>
                </div>
                <div className="flex items-center gap-2">
                  <div className="w-2 h-2 bg-emerald-400 rounded-full"></div>
                  <span className="text-sm text-slate-400">Knight: Genç yetişkin, hareket, macera</span>
                </div>
                <div className="flex items-center gap-2">
                  <div className="w-2 h-2 bg-emerald-400 rounded-full"></div>
                  <span className="text-sm text-slate-400">Queen: Olgun kadınsı enerji, içsel güç</span>
                </div>
                <div className="flex items-center gap-2">
                  <div className="w-2 h-2 bg-emerald-400 rounded-full"></div>
                  <span className="text-sm text-slate-400">King: Olgun erkeksi enerji, ustalık</span>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Elements Info */}
        <div className="bg-slate-800 rounded-xl p-6 border border-slate-700 mb-8">
          <h2 className="text-2xl font-semibold text-slate-100 mb-6">Dört Element ve Anlamları</h2>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
            <div className="text-center p-4 bg-red-900/20 rounded-lg border border-red-700/30">
              <Flame className="h-8 w-8 text-red-400 mx-auto mb-3" />
              <h3 className="font-semibold text-red-200 mb-2">Ateş - Wands</h3>
              <p className="text-red-300 text-xs leading-relaxed">
                Yaratıcılık, tutku, enerji, ruhsal güç, ilham, girişimcilik
              </p>
            </div>
            <div className="text-center p-4 bg-blue-900/20 rounded-lg border border-blue-700/30">
              <Droplets className="h-8 w-8 text-blue-400 mx-auto mb-3" />
              <h3 className="font-semibold text-blue-200 mb-2">Su - Cups</h3>
              <p className="text-blue-300 text-xs leading-relaxed">
                Duygular, ilişkiler, sezgi, ruhsal derinlik, aşk, empati
              </p>
            </div>
            <div className="text-center p-4 bg-gray-800/20 rounded-lg border border-gray-600/30">
              <Sword className="h-8 w-8 text-gray-400 mx-auto mb-3" />
              <h3 className="font-semibold text-gray-200 mb-2">Hava - Swords</h3>
              <p className="text-gray-300 text-xs leading-relaxed">
                Düşünce, mantık, iletişim, çatışma, zihinsel güç, netlik
              </p>
            </div>
            <div className="text-center p-4 bg-green-900/20 rounded-lg border border-green-700/30">
              <Coins className="h-8 w-8 text-green-400 mx-auto mb-3" />
              <h3 className="font-semibold text-green-200 mb-2">Toprak - Pentacles</h3>
              <p className="text-green-300 text-xs leading-relaxed">
                Maddi dünya, para, kariyer, sağlık, pratik işler, istikrar
              </p>
            </div>
          </div>
        </div>

        {/* Important Note */}
        <div className="bg-amber-900/20 border border-amber-700/50 rounded-xl p-6 mb-8">
          <h3 className="text-lg font-semibold text-amber-200 mb-3">⚠️ Önemli Uyarı</h3>
          <p className="text-amber-100 leading-relaxed">
            Tarot kartları sembolik yorumlama araçlarıdır ve kesinlik iddiası taşımazlar. İçerikler tamamen
            merak, eğlence ve kişisel farkındalık amaçlıdır. Yaşamsal kararlar için uzman görüşü alınmalıdır.
          </p>
        </div>

        {/* Navigation */}
        <div className="flex justify-between items-center">
          <Link
            href="/about/tarot/systems/rider-waite"
            className="inline-flex items-center px-4 py-2 bg-slate-800 hover:bg-slate-700 border border-slate-600 rounded-lg text-slate-300 hover:text-slate-100 transition-colors"
          >
            <ArrowLeft className="h-4 w-4 mr-2" />
            Rider-Waite Sistemi
          </Link>

          <Link
            href="/about/tarot/systems/rider-waite/major-arcana"
            className="inline-flex items-center px-4 py-2 bg-purple-600 hover:bg-purple-700 text-white rounded-lg transition-colors"
          >
            Majör Arkana
            <ArrowLeft className="h-4 w-4 ml-2 rotate-180" />
          </Link>
        </div>
      </div>
    </AboutLayout>
  );
}